import { useEffect, useRef, useState } from "react";
import QRCode from "qrcode";

export default function QRCodeGenerator({ url, size = 256, onDataUrlChange }) {
  const canvasRef = useRef(null);
  const [dataUrl, setDataUrl] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    if (!url) {
      setDataUrl("");
      onDataUrlChange?.("");
      return;
    }

    const options = {
      width: size,
      margin: 2,
      color: {
        dark: "#000000",
        light: "#ffffff",
      },
    };

    if (canvasRef.current) {
      QRCode.toCanvas(canvasRef.current, url, options).catch((err) =>
        setError(err.message)
      );
    }

    QRCode.toDataURL(url, options)
      .then((nextDataUrl) => {
        setDataUrl(nextDataUrl);
        onDataUrlChange?.(nextDataUrl);
      })
      .catch((err) => setError(err.message));
  }, [url, size, onDataUrlChange]);

  if (error) return <p style={{ color: "red" }}>Error: {error}</p>;

  return (
    <div style={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
      <canvas ref={canvasRef} aria-label={dataUrl ? "QR code" : "Generating QR code"} />
    </div>
  );
}